import { BriqAgentIntegrationConfiguration, BriqAssistants, UserDataInit } from './briqAgentTypes'
import { currentScriptSrc } from './currentScriptSrc'

export type ConversationInit = {
  conversationType: BriqAssistants | null | undefined
  conversationId?: string | null | undefined
  autoStart?: boolean | undefined
  countryCode?: string | null | undefined
  reportId?: string | null | undefined
  lang?: string | null | undefined
}

export type BuildAgentConfigurationInit = ConversationInit & UserDataInit

const getConversationType = ({ conversationType, reportId }: Partial<ConversationInit>): BriqAssistants | undefined => {
  if (conversationType) return conversationType
  if (reportId) return 'report_assistant'
  return 'purchase_assistant'
}

export const buildAgentConfiguration = ({
  briqDomain,
  conversationId,
  countryCode,
  lang,
  reportId,
  autoStart,
  conversationType
}: BuildAgentConfigurationInit): BriqAgentIntegrationConfiguration => {
  const resolvedConversationType = getConversationType({ conversationType, reportId })

  return {
    apiKey: '762f9a0f-e8b8-465a-b307-68205f48a905',
    briqDomain,
    securityContext: {
      skipUserIdentity: true,
      tokenEndpoint: new URL('/api/token/get', document.location.origin).toString(),
      xsrfEndpoint: new URL('/api/xsrf', document.location.origin).toString()
    },
    endpoints: {
      conversation: new URL(
        'api/ai/ws',
        `${document.location.protocol === 'http:' ? 'ws' : 'wss'}://${document.location.host}/`
      ).toString(),
      conversationHistory: new URL('api/ai/conversation/history', document.location.origin).toString(),
      conversationsCreate: new URL('api/ai/conversation/create', document.location.origin).toString(),
      conversationsDelete: new URL('api/ai/conversation/history', document.location.origin).toString(),
      conversationsList: new URL('api/ai/conversations/list', document.location.origin).toString(),
      conversationsUpdate: new URL('api/ai/conversation/rename', document.location.origin).toString(),
      conversationCheck: new URL('api/ai/conversation/check', document.location.origin).toString(),
      reportDownload: new URL('api/ai/document/download/url', document.location.origin).toString()
    },
    urlTransformers: {
      'application/pdf': new URL('pdf-viewer.html?pdf=:url&backgroundColor=unset', currentScriptSrc()).toString()
    },
    ratings: ['None', 'helpful', 'unhelpful'], // TODO?
    // Set a conversation type to force stricter checks.
    conversationType: resolvedConversationType,
    // Each conversation parameter (e.g., `reportId`) is also retrieved from `document.location.search` (camelCase).
    // Override the default values here (with null, undefined or the corresponding query parameter).
    conversationId: conversationId ?? '',
    ...(resolvedConversationType === 'report_assistant' ? { reportId, countryCode } : {}),
    lang: lang ?? navigator.language,
    autoStart
  }
}
